import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";
import qs from "qs";

export const getBrandCampaignList = async (params: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.BRAND_CAMPAIGN.GET_BRAND_CAMPAIGN_LIST,
    { params: params }
  );

  console.log(
    "🚀 ~ useBrandCampaign.tsx:10 ~ getLeaveType ~ response:",
    response
  );

  return response?.data;
};

export const getBrandCampaignOutletList = async (
  id: number | string,
  params: Record<string, any>
) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.BRAND_CAMPAIGN.GET_BRAND_CAMPAIGN_OUTLET}/${id}`,
    { params: params }
  );

  console.log(
    "🚀 ~ BrandCampaignRepository.ts:24 ~ getBrandCampaignOutletList ~ response:",
    response
  );

  return response?.data;
};

export const getSingleBrandCampaignList = async (id: any) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.BRAND_CAMPAIGN.GET_SINGLE_BRAND_CAMPAIGN}/${id}`
  );

  console.log("🚀 ~ BrandCampaignRepository.ts:42 ~ response:", response);

  return response?.data;
};

export const getDesignations = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.EMPLOYEE.GET_DESIGNATIONS,
    params
  );

  console.log(
    "🚀 ~ BrandCampaignRepository.ts:54 ~ getDesignations ~ response:",
    response
  );

  return response?.data;
};

export const getOutletTypeList = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.BRAND_CAMPAIGN.GET_OUTLET_TYPE_LIST,
    params
  );

  console.log(
    "🚀 ~ BrandCampaignRepository.ts:67 ~ getOutletTypeList ~ response:",
    response
  );

  return response?.data;
};

export const getClassification = async (
  id?: number | string,
  params?: Record<string, any>
) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.BRAND_CAMPAIGN.GET_CLASSIFICATION}/${id}`,
    params
  );

  console.log(
    "🚀 ~ BrandCampaignRepository.ts:82 ~ getClassification ~ response:",
    response
  );

  return response?.data;
};

export const getBrands = async (
  // id?: number | string,
  params?: Record<string, any>
) => {
  console.log("paramsss", params);
  const response = await axiosInstance.get(
    API_ENDPOINTS.BRAND_CAMPAIGN.GET_BRANDS,
    { params: params }
  );

  console.log("🚀 ~ BrandCampaignRepository.ts:102 ~ response:", response);

  return response?.data;
};

export const getBrandCampaignStatus = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.BRAND_CAMPAIGN.GET_BRAND_CAMPAIGN_STATUS,
    params
  );

  console.log("🚀 ~ BrandCampaignRepository.ts:115 ~ response:", response);

  return response?.data;
};

// export const handleMedia = async (file: File) => {
//   const reader = new FileReader();

//   return new Promise<string>((resolve, reject) => {
//     reader.readAsDataURL(file);
//     reader.onload = async () => {
//       const base64Data = reader.result?.toString().split(",")[1];
//       console.log("base64Data", base64Data);
//       let body = {
//         folder_id: "1",
//         media: [base64Data],
//       };

//       try {
//         const response = await axiosInstance.post(
//           API_ENDPOINTS.MEDIA.UPLOAD_MEDIA_BASE64,
//           body
//         );
//         console.log("response", response);

//         if (response?.data?.data[0]) {
//           console.log(
//             "Media uploaded successfully. Media ID:",
//             response?.data?.data[0]
//           );
//           resolve(response?.data?.data[0]);
//         } else {
//           reject(new Error("Failed to get mediaId"));
//         }
//       } catch (error) {
//         console.error("Media upload failed:", error);
//         reject(error);
//       }
//     };

//     reader.onerror = () => {
//       reject(new Error("Failed to read file"));
//     };
//   });
// };

// export const getDesignationPosition = async (params?: Record<string, any>) => {
//   const response = await axiosInstance.get(
//     API_ENDPOINTS.BRAND_CAMPAIGN.GET_DESIGNATION_POSITION,
//     { params: params }
//   );

//   console.log(
//     "🚀 ~ BrandCampaignRepository.ts:165 ~ getDesignationPosition ~ response:",
//     response
//   );

//   return response?.data;
// };

export const getDesignationPosition = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.BRAND_CAMPAIGN.GET_DESIGNATION_POSITION,
    {
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "brackets" }),
      // 👆 this makes GradesId[]=1&GradesId[]=2&GradesId[]=3
    }
  );

  console.log(
    "🚀 ~ BrandCampaignRepository.ts:165 ~ getDesignationPosition ~ response:",
    response
  );

  return response?.data;
};

export const getSGPILists = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.BRAND_CAMPAIGN.GET_SGPI_LISTS,
    { params: params }
  );

  console.log(
    "🚀 ~ BrandCampaignRepository.ts:179 ~ getSGPILists ~ response:",
    response
  );

  return response?.data;
};

export const addBrandCampaign = async (body?: any) => {
  return axiosInstance.post(
    API_ENDPOINTS.BRAND_CAMPAIGN.ADD_BRAND_CAMPAIGN,
    body
  );
};

export const updateBrandCampaign = async (id?: any, body?: any) => {
  return axiosInstance.put(
    `${API_ENDPOINTS.BRAND_CAMPAIGN.UPDATE_BRAND_CAMPAIGN}/${id}`,
    body
  );
};

export const updateBrandCampaignOutlet = async (id?: any, body?: any) => {
  return axiosInstance.put(
    `${API_ENDPOINTS.BRAND_CAMPAIGN.UPDATE_OUTLET_CAMPAIGN}/${id}`,
    body
  );
};
export const publishBrandCampaignStatusChange = async (
  id?: any,
  body?: any
) => {
  return axiosInstance.put(
    `${API_ENDPOINTS.BRAND_CAMPAIGN.PUBLISH_BRAND_CAMPAIGN_STATUS_CHANGE}/${id}`,
    body
  );
};

export const handleMedia = async (file: File) => {
  const reader = new FileReader();

  return new Promise<string>((resolve, reject) => {
    reader.readAsDataURL(file);

    reader.onload = async () => {
      const base64Data = reader.result?.toString().split(",")[1];

      if (!base64Data) {
        return reject(new Error("Failed to convert file to Base64"));
      }

      const mimeType = file.type; // e.g. "image/png", "application/pdf", "application/msword", etc.

      const allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "application/pdf",
        "application/msword", // .doc
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
      ];

      if (!allowedTypes.includes(mimeType)) {
        return reject(new Error(`File type not allowed: ${mimeType}`));
      }

      const body = {
        folder_id: "1",
        media: [base64Data],
        mime_type: mimeType,
        file_name: file.name,
      };

      try {
        const response = await axiosInstance.post(
          API_ENDPOINTS.MEDIA.UPLOAD_MEDIA_BASE64,
          body
        );

        if (response?.data?.data?.[0]) {
          console.log("✅ Media uploaded:", response.data.data[0]);
          resolve(response.data.data[0]); // This should be the mediaId
        } else {
          reject(new Error("Failed to get mediaId"));
        }
      } catch (error) {
        console.error("❌ Media upload failed:", error);
        reject(error);
      }
    };

    reader.onerror = () => {
      reject(new Error("Failed to read file"));
    };
  });
};
